define.alias("shared/utils/redirect", "settings/utils/redirect");